import { FC, useEffect, useState } from 'react';

import { Switch } from 'antd';
import cs from 'classnames';


import { useTranslation } from 'react-i18next';
import { SWITCH_OPTIONS } from '../../constants/uiSettings';
import styles from './StyledSwitch.module.scss';

interface StyledSwitchProps {
  onChange: (isChecked: boolean) => void;
  leftLabel?: string;
  rightLabel?: string;
  isDefaultChecked?: boolean;
  disabled?: boolean;
  noLabels?: boolean;
}

const StyledSwitch: FC<StyledSwitchProps> = ({
  onChange,
  leftLabel,
  rightLabel,
  isDefaultChecked = false,
  disabled = false,
  noLabels = false
}) => {
  const { t } = useTranslation()
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(isDefaultChecked);
  }, [isDefaultChecked]);

  const handleChange = (isChecked: boolean) => {
    setChecked(isChecked);
    onChange(isChecked);
  };

  return (
    <span className={styles.container}>
      <span
        className={cs({
          [styles.switchDisabled]: disabled,
          [styles.switchUnchecked]: !disabled && checked,
          [styles.switchChecked]: !disabled && !checked,
          [styles.switchHideLabel]: noLabels
        })}
      >
        {leftLabel ?? t(SWITCH_OPTIONS.NO)}
      </span>
      <Switch
        onChange={handleChange}
        checked={checked}
        className={cs(styles.switchBoundaries, {
          [styles.switchNoLabels]: noLabels
        })}
        disabled={disabled}
      />
      <span
        className={cs({
          [styles.switchDisabled]: disabled,
          [styles.switchUnchecked]: !disabled && !checked,
          [styles.switchChecked]: !disabled && checked,
          [styles.switchHideLabel]: noLabels
        })}
      >
        {rightLabel ?? t(SWITCH_OPTIONS.YES)}
      </span>
    </span>
  );
};

export default StyledSwitch;
